// extracted by mini-css-extract-plugin
export default {"socials":"SocialMedia_socials__rUe5A","icon":"SocialMedia_icon__Kmc3x"};